import * as React from 'react';
export default function useGrabScroll(parentElementId) {
  const parentElement = document.getElementById(parentElementId);
  const movedRef = React.useRef(false);
  React.useEffect(() => {
    let mouseDown = false;
    let startX;
    let scrollLeft;
    const startDragging = e => {
      if (parentElement) {
        if (movedRef.current) {
          movedRef.current = false;
        }
        mouseDown = true;
        startX = e.pageX - parentElement.offsetLeft;
        scrollLeft = parentElement.scrollLeft;
      }
    };
    const stopDragging = () => {
      mouseDown = false;
    };
    const moveDragging = e => {
      if (parentElement) {
        e.preventDefault();
        if (!mouseDown) {
          return;
        }
        const x = e.pageX - parentElement.offsetLeft;
        const diffX = x - startX;
        if (diffX > 5 || diffX < -5) {
          movedRef.current = true;
        }
        const scrollX = x - startX;
        parentElement.scrollLeft = scrollLeft - scrollX;
      }
    };
    if (parentElement) {
      parentElement.addEventListener('mousemove', moveDragging);
      // Add the event listeners
      parentElement.addEventListener('mousedown', startDragging, false);
      parentElement.addEventListener('mouseup', stopDragging, false);
      parentElement.addEventListener('mouseleave', stopDragging, false);
    }
    return () => {
      document.removeEventListener('mousedown', startDragging);
      document.removeEventListener('mouseup', stopDragging);
      document.removeEventListener('mouseleave', stopDragging);
      document.removeEventListener('mousemove', moveDragging);
    };
  }, [parentElement]);
  return movedRef;
}